import { paths } from '@app/routes/paths';
import { ChildrenNavItem, NavItem } from '@uni-space/uni-components';

export interface FileResponse {
  data: Blob;
  fileName?: string;
}

export interface FetchError {
  response: { data: ErrorPayload };
}

interface ErrorPayload {
  message: string;
}

export interface DefaultSimpleResponse {
  isSuccess: boolean;
  message: string;
  code: string;
  arguments: {
    string: string;
  };
}

export type FetchCtx = { signal?: AbortSignal };

export enum Credential {
  consolidator = 'consolidator',
  dropshipping = 'dropshipping',
  returnLastMile = 'returnLastMile',
  fulfillment = 'fulfillment',
  administration = 'administration',
  manifest = 'manifest',
  xdock = 'xdock',
  qualityControl = 'qualityControl',
  chuteSettings = 'chuteSettings',
}

export enum RouteAccess {
  view = 'view',
  edit = 'edit',
  cancel = 'cancel',
  export = 'export',
  add = 'add',
  supervisor = 'supervisor',
  configurator = 'configurator',
  operator = 'operator',
}

export type AppPath = (typeof paths)[keyof typeof paths];

export type AppNavItem = NavItem<AppPath, Credential, RouteAccess>;
export type AppChildrenNavItem = ChildrenNavItem<AppPath, Credential, RouteAccess>;
export type ErrorDTO = { message?: string; code: string };

/**
 * Коды ошибок шлюза (HTTP 422). Приходят в kebab-case — так их отдаёт
 * WebApiErrorCode на бэкенде, поэтому сравнивать нужно именно с этими строками.
 */
export const ApiErrorCodes = {
  /** Брутто мешка превышает максимально допустимый вес. */
  bagWeightExceeded: 'bag-weight-exceeded',
  /** Брутто мешка слишком сильно расходится с весом посылок и тары. */
  bagWeightMismatch: 'bag-weight-mismatch',
} as const;
